import { Breadcrumbs } from "components/breadcrumbs";
import { FullScreenLoading } from "components/fullScreenLoading";
import { EditOrganizationForm } from "./components";
import { useOne, useParse } from "@refinedev/core";
import { IOrgDetail } from "interfaces";

export const EditOrganization : React.FC = () => {

  const parse = useParse();
  const { params } = parse();

  
  const {
    data,
    isFetching,
    isPreviousData,
    isLoading,
  } = useOne<IOrgDetail>({
    resource: "organization",
    id: params?.id,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });

  const organization = data?.data;

  if (isLoading) {
    return <FullScreenLoading />
  }

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Edit Organization" />
      {organization ? <EditOrganizationForm organization={organization} id={params?.id} /> : <></>}
      {(isFetching && isPreviousData) ? <FullScreenLoading /> : <></>}
    </div>
  );
}